import Modal from "components/DesignSystem/Modal/Modal";
import { Button } from "components/DesignSystem/Button/Button";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { FormikForm } from "components/FormikForm/FormikForm";
import { ModalProps } from "types/utils/modal";
import { useTestIVRCallMutation } from "store/apis/broadcastCall";
import { broadcastIVRTestSchema } from "formValidations/broadcastCallSchema";
import { MobileInput } from "components/DesignSystem/MobileInput/MobileInput";
import { useToast } from "hooks/useToast";

export const IVRTestModal = (props: ModalProps & { messageText: string }) => {
  const { isOpen, close, messageText } = props;
  const [testIVRCall, { isLoading }] = useTestIVRCallMutation();
  const { alertToast, successToast } = useToast();

  const initialValues = {
    mobile_number: "",
    team_member_name: "",
    entity_name: "",
    company_name: "",
  };

  const handleTestMessage = async (values: typeof initialValues) => {
    try {
      await testIVRCall({
        team_member_name: values.team_member_name,
        company_name: values.company_name,
        entity_name: values.entity_name,
        phone_number: values.mobile_number,
        message_text: messageText,
      }).unwrap();

      successToast({
        title: "Test call successful",
        message: "You will receive a call on a provided number.",
      });
      close();
    } catch (error) {
      alertToast({
        title: "Test call failed",
        message:
          "Please check the given mobile number or contact the team if the problem persists.",
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close} modal={true}>
      <Modal.Content size="regular" asChild>
        <FormikForm
          initialValues={initialValues}
          validationSchema={broadcastIVRTestSchema}
          //@ts-ignore
          onSubmit={handleTestMessage}
        >
          {({ isValid, submitForm }) => (
            <>
              <Modal.Header>
                <Modal.Title>Test IVR Calling</Modal.Title>
                <Modal.Close />
              </Modal.Header>
              <Modal.Body className="t-flex t-flex-col t-gap-4">
                <div>
                  <MobileInput
                    name="mobile_number"
                    label="Enter Mobile Number"
                    placeholder="Enter mobile number"
                    required
                  />
                </div>
                <TextInput
                  name="team_member_name"
                  label="Enter value for {{team_member_name}}"
                  placeholder="Enter team member name"
                  required
                />
                <TextInput
                  name="entity_name"
                  label="Enter value for {{entity_name}}"
                  placeholder="Enter entity name"
                  required
                />
                <TextInput
                  name="company_name"
                  label="Enter value for {{company_name}}"
                  placeholder="Enter company name"
                  required
                />
              </Modal.Body>
              <Modal.Footer className="t-flex t-justify-end t-gap-2">
                <Button type="button" onClick={close}>
                  Go Back
                </Button>
                <Button
                  type="button"
                  customType="primary"
                  disabled={isLoading || !isValid}
                  isLoading={isLoading}
                  onClick={submitForm}
                >
                  Get Test Call
                </Button>
              </Modal.Footer>
            </>
          )}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};

IVRTestModal.displayName = "IVRTestModal";
